import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useGetAllActiveCategoryMutation, useAddDropdownMutation, useUpdateDropdownMutation, useGetAllCategoryForDropdownMutation, useGetAllActiveDropdownMutation } from "./Api";
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader"
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";

const AddDropdown = ({
    mode = "add",
    onClose,
    onSave,
    data = null,
}) => {

    const [addDropdownApi, { isLoading }] = useAddDropdownMutation()
    const [updateDropdownApi, { isLoading: updateIsLoading }] = useUpdateDropdownMutation()
    const [getAllActiveCategory, { isLoading: getAllActiveCategoryIsLoading }] = useGetAllActiveCategoryMutation()
    const [getAllCategory, { isLoading: getAllCategoryIsLoading }] = useGetAllCategoryForDropdownMutation()
    const [getAllActiveDropdown, { isLoading: getAllActiveDropdownIsLoading }] = useGetAllActiveDropdownMutation()


    const [category, setCategory] = useState([])
    const [dropdown, setDropdown] = useState([])
    const [status, setStatus] = useState(null)
    const navigate = useNavigate()

    const validationSchema = Yup.object().shape({
        category_name: Yup.string()
            .required('Category is required')
            .trim(),
        // sub_category_type: Yup.string()
        //     .nullable()
        //     .trim(),
        has_sub_category: Yup.string()
            .required("Please select Yes or No"),
        sub_category_type: Yup.string()
            .nullable()
            .trim()
            .when('has_sub_category', {
                is: 'yes',
                then: (schema) =>
                    schema.required('Main Category is required'),
                otherwise: (schema) => schema.nullable()
            }),
        sub_category_name: Yup.string()
            .nullable()
            .trim()
            .when('sub_category_type', {
                is: (value) => value && value !== '',
                then: (schema) =>
                    schema.required('Sub Category is required'),
                otherwise: (schema) => schema.nullable()
            }),

        dropdown_name: Yup.string()
            .required('Dropdown name is required')
            // .matches(/^[A-Za-z ]+$/,
            //     "Enter valid Dropdown Name")
            .trim(),
        display_order: Yup.string()
            .required('Display order is required')
            .matches(/^[0-9]+$/,
                "Enter valid Display Order")
            .trim(),
        status: Yup.string()
            .required('Status is required')
            .trim(),
    });

    const { register, handleSubmit, reset, watch, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });


    const selectedCategoryId = watch("category_name"); // Track selected category
    const selectedSubCategoryType = watch("sub_category_type");
    const hasSubCategory = watch("has_sub_category");

    useEffect(() => {
        if (!data?.sub_category) {
            setValue("sub_category_name", "");
        }

    }, [selectedCategoryId]);

    useEffect(() => {
        // Only run when selectedCategoryId changes
        const selectedCategory = category.find(
            (c) => c.id === Number(selectedCategoryId)
        );

        if (selectedCategoryId && category.length > 0) {

            if (selectedCategory?.status === "active") {
                setStatus(true);
            } else {
                setStatus(false);
            }
        }

    }, [selectedCategoryId, category]);

    useEffect(() => {

        if (data) {

            getAllCategoryForDropdown()

            reset({
                category_name: data.category,
                sub_category_type: data.sub_category_type ? data.sub_category_type : "",
                dropdown_name: data.dropdown_name,
                sub_category_name: data.sub_category ? data.sub_category : "",
                display_order: data.sort_order,
                status: data.status,
                has_sub_category: data.sub_category_type ? "yes" : "no",
            });

        }
        // console.log(status, 'status')
    }, [])

    useEffect(() => {
        if (!data) {
            getActiveCategory()
        }
    }, [])

    useEffect(() => {
        getAllDropdown()
    }, [])

    const resetButton = () => {
        // reset({
        //     category_name: "",
        //     sub_category_type: "",
        //     sub_category_name: "",
        //     display_order: "",
        //     dropdown_name: "",
        //     status: "",
        // });
        reset({
            category_name: "",
            has_sub_category: "",
            display_order: "",
            dropdown_name: "",
            status: "",
        });
    };

    const getAllDropdown = async () => {
        try {
            const getActiveDropdownRes = await getAllActiveDropdown()
            // console.log(getActiveDropdownRes.data.data, 'getActiveDropdownRes')

            if (getActiveDropdownRes?.data?.success) {
                setDropdown(getActiveDropdownRes.data.data)
            } else {
                if (shouldLogout(getActiveDropdownRes.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }


    const getActiveCategory = async () => {
        try {
            const getActiveCategoryRes = await getAllActiveCategory()

            if (getActiveCategoryRes?.data?.success) {
                setCategory(getActiveCategoryRes.data.data)
            } else {
                if (shouldLogout(getActiveCategoryRes.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const getAllCategoryForDropdown = async () => {
        try {
            const getCategoryRes = await getAllCategory()
            if (getCategoryRes?.data?.success) {
                setCategory(getCategoryRes.data.data)
            } else {
                if (shouldLogout(getCategoryRes.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    useEffect(() => {
        if (hasSubCategory === "no") {
            setValue("sub_category_type", "");
            setValue("sub_category_name", "");
        }
    }, [hasSubCategory]);

    const onSubmit = async (payload) => {
        try {
            if (mode == 'add') {

                const values = {
                    category: payload.category_name,
                    // sub_category_type: payload.sub_category_type ? payload.sub_category_type : null,
                    // sub_category: payload.sub_category_name ? payload.sub_category_name : null,
                    sub_category_type:
                        payload.has_sub_category === "yes"
                            ? payload.sub_category_type || null
                            : null,

                    sub_category:
                        payload.has_sub_category === "yes"
                            ? payload.sub_category_name || null
                            : null,
                    dropdown_name: payload.dropdown_name,
                    sort_order: Number(payload.display_order),
                    status: payload.status,
                }

                const response = await addDropdownApi(values)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {
                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }
                    ToastrService.error(response.error.data.message);
                }

            } else {

                const values = {
                    category: payload.category_name,
                    sub_category_type: payload.sub_category_type ? payload.sub_category_type : null,
                    sub_category: payload.sub_category_name ? payload.sub_category_name : null,
                    dropdown_name: payload.dropdown_name,
                    sort_order: Number(payload.display_order),
                    status: payload.status,
                    id: data.id
                }

                const response = await updateDropdownApi(values)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {
                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }
                    ToastrService.error(response.error.data.message);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {getAllCategoryIsLoading || isLoading || updateIsLoading || getAllActiveCategoryIsLoading || getAllActiveDropdownIsLoading ? <Loader /> :
                <>
                    <div className="offcanvas offcanvas-end show" style={{ visibility: "visible" }} tabIndex="-1">

                        <div className="offcanvas-header px-4 py-3">

                            <div>
                                <h3 className="mb-1 drawer-header">
                                    {mode === "add" ? "Create New Dropdown" : "Manage Dropdown"}
                                </h3>
                                <small className="text-muted">{mode === "add" ? "Fill in the details below to create a New Dropdown." : "Update the details below to Manage Dropdown"}</small>
                            </div>

                            <button
                                type="button"
                                className="btn-close text-reset"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>

                        </div>


                        <div className="offcanvas-body px-4 py-3">

                            <form autoComplete="off" noValidate onSubmit={handleSubmit(onSubmit)}>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Category <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        id="category_name"
                                        name="category_name"
                                        {...register('category_name')}
                                        className="custom-select"
                                    >
                                        <option value="">Select Category</option>
                                        {category.length > 0 &&
                                            category.map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.category}
                                                </option>
                                            ))}
                                    </select>
                                    {errors.category_name && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.category_name.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Enable Sub Categories <span className="text-danger">*</span>
                                    </label>

                                    <select
                                        id="has_sub_category"
                                        name="has_sub_category"
                                        {...register('has_sub_category')}
                                        className="custom-select"
                                    >
                                        <option value="">Select Option</option>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>

                                    {errors.has_sub_category && (
                                        <p
                                            className="mt-2"
                                            style={{
                                                color: "#d93025",
                                                fontFamily: "revert",
                                                marginLeft: '1%'
                                            }}
                                        >
                                            {errors.has_sub_category.message}
                                        </p>
                                    )}
                                </div>


                                {hasSubCategory === "yes" && (

                                    <>
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Main Category
                                            </label>
                                            <select
                                                id="sub_category_type"
                                                name="sub_category_type"
                                                {...register('sub_category_type')}
                                                className="custom-select"
                                            >
                                                <option value="">Select Category</option>
                                                {category.length > 0 &&
                                                    category.map((item, index) => (
                                                        <option key={index} value={item.id}>
                                                            {item.category}
                                                        </option>
                                                    ))}
                                            </select>
                                            {errors.sub_category_type && (
                                                <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                                    {errors.sub_category_type.message}
                                                </p>
                                            )}
                                        </div>



                                        <div className="mb-3">
                                            <label className="form-label">
                                                Sub Category
                                            </label>

                                            <select
                                                id="sub_category_name"
                                                name="sub_category_name"
                                                {...register('sub_category_name')}
                                                className="custom-select"
                                                disabled={!selectedSubCategoryType}
                                            >
                                                <option value="">
                                                    {selectedSubCategoryType
                                                        ? "Select Sub Category"
                                                        : "Please select Main Category first"
                                                    }
                                                </option>

                                                {dropdown
                                                    .filter(
                                                        (item) => item.category == selectedSubCategoryType
                                                    )
                                                    .map((item, index) => (
                                                        <option key={index} value={item.id}>
                                                            {item.dropdown_name}
                                                        </option>
                                                    ))}
                                            </select>

                                            {errors.sub_category_name && (
                                                <p
                                                    className="mt-2"
                                                    style={{
                                                        color: "#d93025",
                                                        fontFamily: "revert",
                                                        marginLeft: '1%'
                                                    }}
                                                >
                                                    {errors.sub_category_name.message}
                                                </p>
                                            )}
                                        </div>
                                    </>

                                )}




                                <div className="mb-3">
                                    <label className="form-label">
                                        Dropdown Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="dropdown_name"
                                        name='dropdown_name'
                                        placeholder='Enter the Dropdown name'
                                        {...register('dropdown_name')}
                                        className="form-control"

                                    />
                                    {errors.dropdown_name && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.dropdown_name.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Display Order <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="display_order"
                                        name='display_order'
                                        placeholder='Enter the Display order'
                                        {...register('display_order')}
                                        className="form-control"
                                    />
                                    {errors.display_order && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.display_order.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Status <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        id="status"
                                        name="status"
                                        {...register('status')}
                                        className="custom-select"
                                    >
                                        <option value="">Select status</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                    {errors.status && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.status.message}
                                        </p>
                                    )}

                                </div>

                                <div className="d-flex gap-2 mt-4">
                                    <button type="submit" className="btn btn-primary">
                                        {mode === "add" ? "Create dropdown" : "Update dropdown"}
                                    </button>

                                    {mode === "add" && (
                                        <button type="button" className="btn btn-secondary" onClick={resetButton}>
                                            Reset
                                        </button>
                                    )}
                                </div>

                            </form>
                            {status !== null && status == false && (
                                <div className="alert-box">
                                    <strong>Note:</strong> This category has been deactivated by the admin.
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Backdrop */}
                    <div className="offcanvas-backdrop fade show" onClick={onClose}></div>

                </>
            }
        </div>

    );
};

export default AddDropdown;